var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-header"},[_c('v-slide-y-transition',{attrs:{"appear":""}},[_c('v-img',{staticClass:"c-header__logo",attrs:{"src":require("@/assets/logo-nutrimix-distribuidora.svg"),"contain":"","max-height":"auto","max-width":"190"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }